/*#__PURE__*/ export default JSON.parse('{"key":"affiliateBetSharing","type":"root","nullable":true,"items":[{"key":"enabled","def":false,"type":"bool"}]}');